










import { Component, Mixins, Emit } from "vue-property-decorator";
import OptionCardSelector from "../../system/selectors/OptionCardSelector.vue";
import { DepartmentGroupSelectableMixin } from "./mixins";

@Component({
  components: {
    selector: OptionCardSelector,
  },
})
export default class DepartmentGroupFinder extends Mixins(DepartmentGroupSelectableMixin) {
  @Emit("click")
  onClicked() {}
}
